/**
 * Ultra EXTREME zoom / month localStorage helpers (verbatim lift).
 */

export const LS_ULTRA_MONTH_KEY = "__DV_EXTREME_MONTH";
export const LS_ULTRA_ZOOM_KEY = "__DV_EXTREME_ZOOM_PCT";
export const ULTRA_ZOOM_PERCENT_LEVELS = [
   40, 50, 60, 70, 80, 90, 100, 110, 120,
];
export const ULTRA_ZOOM_DEFAULT_PERCENT = 100;
export const ULTRA_ZOOM_MIN_PERCENT = Math.min(...ULTRA_ZOOM_PERCENT_LEVELS);
export const ULTRA_ZOOM_MAX_PERCENT = Math.max(...ULTRA_ZOOM_PERCENT_LEVELS);

export function clampUltraZoomPercent(value) {
   const numeric = Number(value);
   if (!Number.isFinite(numeric)) return ULTRA_ZOOM_DEFAULT_PERCENT;
   return Math.max(
      ULTRA_ZOOM_MIN_PERCENT,
      Math.min(ULTRA_ZOOM_MAX_PERCENT, numeric),
   );
}

export function serializeUltraZoomPercent(value) {
   const clamped = clampUltraZoomPercent(value);
   const rounded = Math.round(clamped * 10) / 10;
   const roundedInt = Math.round(rounded);
   if (Math.abs(rounded - roundedInt) < 0.05) return roundedInt;
   return rounded;
}

export function closestUltraZoomPercent(value) {
   const current = clampUltraZoomPercent(value);
   let best = ULTRA_ZOOM_PERCENT_LEVELS[0];
   let bestDiff = Number.POSITIVE_INFINITY;
   for (const zoomPercent of ULTRA_ZOOM_PERCENT_LEVELS) {
      const diff = Math.abs(zoomPercent - current);
      if (diff < bestDiff) {
         bestDiff = diff;
         best = zoomPercent;
      }
   }
   return best;
}

export function safeReadUltraMonthKey() {
   if (typeof window === "undefined") return null;
   try {
      return localStorage.getItem(LS_ULTRA_MONTH_KEY);
   } catch {
      return null;
   }
}

export function safeWriteUltraMonthKey(value) {
   if (typeof window === "undefined") return;
   try {
      localStorage.setItem(LS_ULTRA_MONTH_KEY, String(value || ""));
   } catch {}
}

export function safeReadUltraZoomPercent() {
   if (typeof window === "undefined") return null;
   try {
      const raw = localStorage.getItem(LS_ULTRA_ZOOM_KEY);
      const parsed = Number(raw);
      return Number.isFinite(parsed) ? parsed : null;
   } catch {
      return null;
   }
}

export function safeWriteUltraZoomPercent(value) {
   if (typeof window === "undefined") return;
   try {
      localStorage.setItem(
         LS_ULTRA_ZOOM_KEY,
         String(serializeUltraZoomPercent(value)),
      );
   } catch {}
}

